'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertLevelCell = AlertLevelCell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AlertLevelCellClasses = require('./AlertLevelCellClasses');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function AlertLevelCell(_ref) {
  var alertLevelId = _ref.alertLevelId,
      children = _ref.children;
  var displayClass = (0, _AlertLevelCellClasses.getAlertLevelClass)(alertLevelId);
  return _react2['default'].createElement('td', {
    className: displayClass
  }, children);
}

AlertLevelCell.propTypes = {
  alertLevelId: _propTypes2['default'].number,
  children: _propTypes2['default'].node
};
AlertLevelCell.defaultProps = {
  alertLevelId: null,
  children: null
};